/**
 * Avatar Image Resolution — turns an avatarCatalog.js entry into a
 * displayable image URL. Kept separate from js/engine/avatarCatalog.js
 * (pure content/data, no render deps) and js/engine/progress.js (pure
 * state, no render deps) since this is the one place that actually needs
 * js/engine/render/unitSprites.js.
 */

import { buildSpriteBitmap } from '../engine/render/unitSprites.js';
import { getCardThumbUrl } from '../data/cardThumbUrl.js';
import { getCardImageUrl } from '../data/cards.js';

export function resolveAvatarImageUrl(avatarEntry) {
  if (!avatarEntry) return null;
  if (avatarEntry.tier === 'artwork') {
    return avatarEntry.image ? (getCardThumbUrl(avatarEntry.image, 'm') || getCardImageUrl(avatarEntry.image)) : null;
  }
  if (avatarEntry.tier === 'sprite') {
    // buildSpriteBitmap() returns { normal, flash, size } - two baked
    // canvases (idle pose + white hit-flash variant), not a bare canvas.
    const baked = buildSpriteBitmap(avatarEntry.unitType, avatarEntry.race, 'western');
    try {
      return baked?.normal ? baked.normal.toDataURL() : null;
    } catch (err) {
      console.error('[avatarImage] toDataURL failed for', avatarEntry.id, err);
      return null;
    }
  }
  return null;
}
